import React, { ReactElement, useState, useEffect } from "react";
import { TextField, MenuItem, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import { IntlShape } from "react-intl";
import { ActionWithPayload } from "../../utils/action-helper";
import { useUsersForRole } from "./components/DealsFilterForAll/hooks/useUsersForRole";

import { IFunnelState } from "../../interfaces/funnelStates";
import { ITariffType } from "../../interfaces/tariffs";

interface IUsersFilterMenu {
  intl: IntlShape;
  currentFunnelState: string | undefined;
  funnelStates: IFunnelState[] | undefined;
  setFunnelState: (payload: string) => ActionWithPayload<"funnelStates/SET_FUNNEL_STATE", string>;
  tariffsTypes: ITariffType[] | undefined;
  usersFilterTariff: string;
  setUsersFilterTariff: (payload: string) => ActionWithPayload<"tariffs/USERS_FILTER_SET_TARIFF", string>;
  userRoles: any[] | undefined;
  setCurrentRoles: (payload: any) => ActionWithPayload<"users/SET_CURRENT_ROLES", any>;
  currentRoles: string | undefined;
  setUserFiltersEmail: any;
  setUserFiltersPhone: any;
  fetchUserFilters: any;
  clearUserFilters: any;
  userFiltersEmail: string | undefined;
  userFiltersPhone: string | undefined;
  setUserBoughtTariff: any;
  boughtTariff: boolean;
  handleSegmentFilter: (key: string, value: string, clear?: boolean) => void;
  selectedSegments: any;
  segmentTitles: Array<any>;
  userActive: boolean | undefined;
  setUserActive: any;
  isAdmin: boolean;
  managerIdSelected: number;
  setManagerIdSelected: (payload: number) => ActionWithPayload<"users/SET_MANAGER_ID_SELECTED", number>;
}

const UsersFilterMenu: React.FC<IUsersFilterMenu> = ({
  intl,
  currentFunnelState,
  funnelStates,
  setFunnelState,

  tariffsTypes,
  usersFilterTariff,
  setUsersFilterTariff,
  userRoles,
  setCurrentRoles,
  currentRoles,

  setUserFiltersEmail,
  setUserFiltersPhone,
  userFiltersEmail,
  userFiltersPhone,

  clearUserFilters,
  fetchUserFilters,

  boughtTariff,
  setUserBoughtTariff,
  handleSegmentFilter,
  selectedSegments,
  segmentTitles,
  userActive,
  setUserActive,
  isAdmin,
  managerIdSelected,
  setManagerIdSelected,
}): ReactElement => {
  const [isSearchEmail, setSearchEmail] = useState("phone");
  const [fetchUsersRole, loadingUsers, usersRole] = useUsersForRole();

  const handleChange = e => {
    setSearchEmail(e.target.value);
  };

  useEffect(() => {
    if (isSearchEmail === "email" && userFiltersEmail) {
      fetchUserFilters({ email: userFiltersEmail });
    }
    if (isSearchEmail === "phone" && userFiltersPhone) {
      fetchUserFilters({ phone: userFiltersPhone });
    }
  }, [userFiltersPhone, userFiltersEmail, fetchUserFilters, isSearchEmail]);

  useEffect(() => {
    fetchUsersRole(1, 999, "ROLE_MANAGER");
  }, [fetchUsersRole]);

  useEffect(() => {
    if (currentRoles !== "ROLE_VENDOR" && currentRoles !== "ROLE_BUYER" && managerIdSelected !== 0) {
      setManagerIdSelected(0);
    }
  }, [currentRoles, managerIdSelected, setManagerIdSelected]);

  return (
    <div>
      <TextField
        select
        margin="normal"
        label={intl.formatMessage({ id: "SUBMENU.USER.FILTERS_ROLE" })}
        value={currentRoles}
        onChange={e => {
          setCurrentRoles(e.target.value);
          setUsersFilterTariff("Все");
          setFunnelState("Все");
          handleSegmentFilter("", "", true);
        }}
        name="roles"
        variant="outlined"
      >
        <MenuItem value={"Все"}>Все</MenuItem>
        {userRoles &&
          userRoles.map(userRole => (
            <MenuItem key={userRole.id} value={userRole.name}>
              {userRole.label}
            </MenuItem>
          ))}
      </TextField>

      <TextField
        select
        margin="normal"
        label={intl.formatMessage({ id: "SUBMENU.USER.FILTERS_TARIFF" })}
        value={usersFilterTariff}
        onChange={e => setUsersFilterTariff(e.target.value)}
        name="tariff"
        variant="outlined"
        disabled={!currentRoles || currentRoles === "Все" || currentRoles === "ROLE_ADMIN" || currentRoles === "ROLE_MANAGER"}
      >
        <MenuItem value={"Все"}>Все</MenuItem>
        {tariffsTypes &&
          tariffsTypes.map(tariffType => (
            <MenuItem key={tariffType.id} value={tariffType.id}>
              {tariffType.name}
            </MenuItem>
          ))}
      </TextField>

      {segmentTitles?.length
        ? segmentTitles?.map(e => {
            let segmentNum = e?.name?.split("_");

            if (currentRoles === "ROLE_VENDOR" && e.name.indexOf("vendor") !== -1) {
              return (
                <TextField
                  key={e?.name + e?.text}
                  select
                  margin="normal"
                  label={e?.text || ""}
                  value={selectedSegments?.[segmentNum[0]] || "Все"}
                  onChange={item => handleSegmentFilter(segmentNum[0], item.target.value)}
                  name={segmentNum[0] ?? ""}
                  placeholder="Все"
                  variant="outlined"
                >
                  <MenuItem value={"Все"}>Все</MenuItem>
                  <MenuItem value={"A"}>A</MenuItem>
                  <MenuItem value={"B"}>B</MenuItem>
                  <MenuItem value={"C"}>C</MenuItem>
                </TextField>
              );
            } else if (currentRoles === "ROLE_BUYER" && e.name.indexOf("buyer") !== -1) {
              return (
                <TextField
                  key={e?.name + e?.text}
                  select
                  margin="normal"
                  label={e?.text || ""}
                  value={selectedSegments?.[segmentNum[0]] || "Все"}
                  onChange={item => handleSegmentFilter(segmentNum[0], item.target.value)}
                  name={segmentNum[0] ?? ""}
                  placeholder="Все"
                  variant="outlined"
                >
                  <MenuItem value={"Все"}>Все</MenuItem>
                  <MenuItem value={"A"}>A</MenuItem>
                  <MenuItem value={"B"}>B</MenuItem>
                  <MenuItem value={"C"}>C</MenuItem>
                </TextField>
              );
            }
            return <></>;
          })
        : null}

      {/*<FormControlLabel
        label="Покупал тариф"
        name="boughtTariff"
        control={<Checkbox checked={boughtTariff} onChange={e => setUserBoughtTariff(!boughtTariff)} />}
      />*/}

      <TextField
        select
        margin="normal"
        label={intl.formatMessage({ id: "SUBMENU.USER.FILTERS_STATUS" })}
        value={currentFunnelState}
        onChange={e => setFunnelState(e.target.value)}
        name="status"
        variant="outlined"
        disabled={!currentRoles || currentRoles === "Все" || currentRoles === "ROLE_ADMIN" || currentRoles === "ROLE_MANAGER"}
      >
        <MenuItem value={"Все"}>Все</MenuItem>
        {funnelStates &&
          funnelStates.map((funnelState, index) => (
            <MenuItem key={`${funnelState.id}+${index}`} value={funnelState.id}>
              {funnelState.name}
            </MenuItem>
          ))}
      </TextField>

      {isAdmin && (
        <TextField
          select
          margin="normal"
          label={intl.formatMessage({ id: "FILTER.FORM.WORK_WITH_USER" })}
          value={typeof userActive === "boolean" ? userActive.toString() : "null"}
          onChange={e => {
            const value = JSON.parse(e.target.value);
            setUserActive(value);
          }}
          variant="outlined"
        >
          <MenuItem value={"true"}>Работаем</MenuItem>
          <MenuItem value={"false"}>Не работаем</MenuItem>
          <MenuItem value={"null"}>Все</MenuItem>
        </TextField>
      )}

      {(currentRoles === "ROLE_VENDOR" || currentRoles === "ROLE_BUYER") && (
        <TextField
          select
          margin="normal"
          label={intl.formatMessage({ id: "FILTER.FORM.MANAGER" })}
          value={managerIdSelected || 0}
          disabled={loadingUsers}
          onChange={e => {
            setManagerIdSelected(Number(e.target.value));
          }}
          variant="outlined"
        >
          <MenuItem value={0}>Все</MenuItem>
          {usersRole &&
            usersRole.map(
              item =>
                item.roles[1] !== "ROLE_MANAGER" && (
                  <MenuItem key={item.id} value={item.id}>
                    {(item.firstname ? item.firstname : "") +
                      " " +
                      (item.surname ? item.surname : "") +
                      " " +
                      (!item.firstname && !item.surname ? item.email || item.phone : "")}
                  </MenuItem>
                )
            )}
        </TextField>
      )}

      <RadioGroup name="emailSender" value={isSearchEmail} onChange={handleChange}>
        <FormControlLabel value="phone" label="Поиск по телефону" control={<Radio />} />
        <FormControlLabel value="email" label="Поиск по email" control={<Radio />} />
      </RadioGroup>

      {isSearchEmail === "email" ? (
        <TextField
          margin="normal"
          label={intl.formatMessage({ id: "SUBMENU.USER.FILTERS_SEARCH_EMAIL" })}
          value={userFiltersEmail}
          onChange={e => {
            setUserFiltersEmail(e.target.value);
          }}
          name={userFiltersEmail}
          variant="outlined"
        />
      ) : (
        <TextField
          margin="normal"
          label={intl.formatMessage({ id: "SUBMENU.USER.FILTERS_SEARCH_PHONE" })}
          value={userFiltersPhone}
          onChange={e => {
            setUserFiltersPhone(e.target.value);
          }}
          name="searchPhone"
          variant="outlined"
        />
      )}
    </div>
  );
};

export default UsersFilterMenu;
